import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6355c0ed")

_pushScopeId("data-v-6355c0ed")
const _hoisted_1 = {
  class: "container popup-container",
  id: "documents-filter"
}
const _hoisted_2 = {
  key: 0,
  style: {"margin-top":"20px"}
}
const _hoisted_3 = { class: "documents-filter-title" }
const _hoisted_4 = { class: "filter-block" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { for: "product-select" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "product-select" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { for: "product-select" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { for: "product-select" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "product-select" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "product-select" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "product-select" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { for: "product-select" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_25 = { class: "documents-filter-footer" }
const _hoisted_26 = { class: "second-row-btns" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "middle-hidden-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('title.document_filters')), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('label.customer_name')), 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.customer = $event)),
                type: "text",
                class: "bookit-input order-input w100"
              }, null, 512), [
                [_vModelText, _ctx.filter.customer]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('label.order_number')), 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.orderNumber = $event)),
                type: "number",
                class: "bookit-input order-input w100"
              }, null, 512), [
                [_vModelText, _ctx.filter.orderNumber]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.document_number')), 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.number = $event)),
                type: "number",
                class: "bookit-input order-input w100"
              }, null, 512), [
                [_vModelText, _ctx.filter.number]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('documents.user')), 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.creatorName = $event)),
                type: "text",
                class: "bookit-input order-input w100"
              }, null, 512), [
                [_vModelText, _ctx.filter.creatorName]
              ])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('label.amount')), 1),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.amount = $event)),
                type: "number",
                class: "bookit-input order-input w100"
              }, null, 512), [
                [_vModelText, _ctx.filter.amount]
              ])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('label.create_dates')), 1),
              _createVNode("div", null, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.fromDate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged
                }, null, 8, ["modelValue", "onDateSelect"]),
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.dateRange.toDate,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  minDate: _ctx.dateRange.fromDate,
                  ref: "calendar",
                  onDateSelect: _ctx.dateChanged
                }, null, 8, ["modelValue", "minDate", "onDateSelect"])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('label.doc_type')), 1),
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.filter.type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter.type = $event)),
                  valueProp: "id",
                  label: "name",
                  options: _ctx.documentType,
                  id: 'type-select-' + _ctx.i,
                  "close-on-select": true,
                  class: "custom-multiselect-input"
                }, {
                  caret: _withId(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "id"]),
                (_ctx.filter.type)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.type = null))
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('title.currency')), 1),
              _createVNode("div", _hoisted_23, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.filter.currency,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter.currency = $event)),
                  valueProp: "id",
                  label: "name",
                  options: _ctx.currenciesType,
                  id: 'type-select-' + _ctx.i,
                  "close-on-select": true,
                  class: "custom-multiselect-input"
                }, {
                  caret: _withId(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "id"]),
                (_ctx.filter.currency)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter.currency = null))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_25, [
            _createVNode("div", null, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args))),
                class: "search-filter-button"
              }, _toDisplayString(_ctx.$t('button.search')), 1)
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("button", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.Close())),
                type: "button"
              }, _toDisplayString(_ctx.$t('button.close')), 1),
              _hoisted_27,
              _createVNode("button", {
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.ResetFilter())),
                type: "button"
              }, _toDisplayString(_ctx.$t('button.selectAll')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})